import {
  Instagram,
  Facebook,
  Twitter,
  MapPin,
  Phone,
  Mail,
} from "lucide-react";
import { useLanguage } from "../lib/LanguageContext";

export const Footer = () => {
  const { t } = useLanguage();
  const year = new Date().getFullYear();
  const links = [
    { href: "#home", label: t("nav_home"), key: "home" },
    { href: "#apartments", label: t("nav_apartments"), key: "apartments" },
    { href: "#facilities", label: t("nav_facilities"), key: "facilities" },
    { href: "#location", label: t("nav_location"), key: "location" },
    { href: "#gallery", label: t("nav_gallery"), key: "gallery" },
    { href: "#contact", label: t("nav_contact"), key: "contact" },
  ];
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#0a192f] text-[#faf9f6]/85 pt-20 pb-10 relative overflow-hidden"
    >
      <div className="absolute inset-0 grain pointer-events-none" />
      <div className="relative max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-10">
          <div className="md:col-span-5">
            <div className="flex items-baseline gap-2">
              <span className="font-serif italic text-4xl">Athina</span>
              <span className="text-[10px] uppercase tracking-[0.32em] opacity-80">
                {t("brand_villas")}
              </span>
            </div>
            <p className="mt-6 font-light text-white/70 max-w-sm leading-relaxed">
              {t("foot_tagline")}
            </p>
            <div className="mt-8 flex gap-3">
              {[Instagram, Facebook, Twitter].map((Icon, i) => (
                <a
                  key={i}
                  href="#"
                  data-testid={`social-link-${i}`}
                  className="h-10 w-10 rounded-full border border-white/20 inline-flex items-center justify-center hover:bg-white hover:text-[#0a192f] transition-colors"
                  aria-label="Social link"
                >
                  <Icon className="h-4 w-4" strokeWidth={1.4} />
                </a>
              ))}
            </div>
          </div>

          <div className="md:col-span-3">
            <div className="text-[10px] uppercase tracking-[0.28em] text-[#c9d8c5] mb-5">
              {t("foot_quick")}
            </div>
            <ul className="space-y-3 font-light">
              {links.map((l) => (
                <li key={l.key}>
                  <a
                    href={l.href}
                    data-testid={`footer-link-${l.key}`}
                    className="text-white/70 hover:text-white transition-colors text-sm"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <div className="text-[10px] uppercase tracking-[0.28em] text-[#c9d8c5] mb-5">
              {t("foot_facilities")}
            </div>
            <ul className="space-y-3 font-light text-white/70 text-sm">
              <li>{t("foot_fac_pool")}</li>
              <li>{t("foot_fac_wifi")}</li>
              <li>{t("foot_fac_parking")}</li>
              <li>{t("foot_fac_bbq")}</li>
              <li>{t("foot_fac_kids")}</li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <div className="text-[10px] uppercase tracking-[0.28em] text-[#c9d8c5] mb-5">
              {t("foot_contact")}
            </div>
            <ul className="space-y-4 font-light text-white/75 text-sm">
              <li className="flex items-start gap-2">
                <MapPin
                  className="h-4 w-4 mt-0.5 text-[#c9d8c5]"
                  strokeWidth={1.4}
                />
                <span>
                  Αθηνά Βίλας Ιστρο,
                  <br />
                  Kalo Chorio 721 00, Crete
                </span>
              </li>
              <li className="flex items-center gap-2">
                <Phone className="h-4 w-4 text-[#c9d8c5]" strokeWidth={1.4} />
                <span>697 400 3022</span>
              </li>
              <li className="flex items-center gap-2">
                <Mail className="h-4 w-4 text-[#c9d8c5]" strokeWidth={1.4} />
                <a
                  href="mailto:athnera@yahoo.com"
                  className="hover:text-white transition-colors"
                >
                  athnera@yahoo.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-white/50">
          <div>© {year} {t("foot_copyright")}</div>
          <div className="uppercase tracking-[0.28em] text-[10px]">
            {t("foot_crafted")}
          </div>
        </div>
      </div>
    </footer>
  );
};
